module.exports = __webpack_public_path__ + "static/media/umami.16a82cce.jpg";